interface TranscriptBubbleProps {
  isRep: boolean;
  timestamp: string;
  content: string;
  isDarkMode: boolean;
  repName?: string;
  customerName?: string;
}

export default function TranscriptBubble({ isRep, timestamp, content, isDarkMode, repName, customerName }: TranscriptBubbleProps) {
  // Function to get initials from a name
  const getInitials = (name: string): string => {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2); // Limit to 2 characters
  };

  // Get the appropriate initials
  const displayInitials = isRep 
    ? (repName ? getInitials(repName) : 'R')
    : (customerName ? getInitials(customerName) : 'C');

  return (
    <div className={`flex gap-3 ${isRep ? '' : 'flex-row-reverse'}`}>
      <div className={`w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-bold ${
        isRep ? 'bg-[#1a9f6b] text-white' : 'bg-green-600 text-white'
      }`}>
        {displayInitials}
      </div>
      <div className={`flex-1 ${isRep ? 'text-left' : 'text-right'}`}>
        <div className={`inline-block rounded-lg px-4 py-2 max-w-[80%] ${
          isRep
            ? isDarkMode ? 'bg-[#1a2424] text-gray-100' : 'bg-gray-200 text-gray-900'
            : isDarkMode ? 'bg-[#1a9f6b]/20 text-gray-100' : 'bg-[#1a9f6b]/10 text-gray-900'
        }`}>
          {timestamp && (
            <div className={`text-xs opacity-60 mb-1 ${isRep ? 'text-left' : 'text-right'}`}>
              {timestamp}
            </div>
          )}
          <p className="text-sm leading-relaxed">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
}
